/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Resume_Time_HintInputs */

const en_onboarding_resume_time_hint = /** @type {(inputs: Onboarding_Resume_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~30 seconds · You can always edit later`)
};

const de_onboarding_resume_time_hint = /** @type {(inputs: Onboarding_Resume_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~30 Sekunden · du kannst es später immer bearbeiten`)
};

const fr_onboarding_resume_time_hint = /** @type {(inputs: Onboarding_Resume_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~30 secondes · Tu peux toujours modifier plus tard`)
};

const es_onboarding_resume_time_hint = /** @type {(inputs: Onboarding_Resume_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~30 segundos · Siempre puede editar más tarde`)
};

const it_onboarding_resume_time_hint = /** @type {(inputs: Onboarding_Resume_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~30 secondi · Puoi sempre modificare in seguito`)
};

const nl_onboarding_resume_time_hint = /** @type {(inputs: Onboarding_Resume_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~30 seconden · Je kunt altijd later bewerken`)
};

const pl_onboarding_resume_time_hint = /** @type {(inputs: Onboarding_Resume_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~30 sekund · Zawsze możesz edytować później`)
};

const fi_onboarding_resume_time_hint = /** @type {(inputs: Onboarding_Resume_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~30 sekuntia · Voit aina muokata myöhemmin`)
};

const da_onboarding_resume_time_hint = /** @type {(inputs: Onboarding_Resume_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~30 sekunder · Du kan altid redigere senere`)
};

const sv_onboarding_resume_time_hint = /** @type {(inputs: Onboarding_Resume_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~30 sekunder · Du kan alltid redigera senare`)
};

/**
* | output |
* | --- |
* | "~30 seconds · You can always edit later" |
*
* @param {Onboarding_Resume_Time_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_resume_time_hint = /** @type {((inputs?: Onboarding_Resume_Time_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Resume_Time_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_resume_time_hint(inputs)
	if (locale === "fr") return fr_onboarding_resume_time_hint(inputs)
	if (locale === "es") return es_onboarding_resume_time_hint(inputs)
	if (locale === "it") return it_onboarding_resume_time_hint(inputs)
	if (locale === "nl") return nl_onboarding_resume_time_hint(inputs)
	if (locale === "pl") return pl_onboarding_resume_time_hint(inputs)
	if (locale === "fi") return fi_onboarding_resume_time_hint(inputs)
	if (locale === "da") return da_onboarding_resume_time_hint(inputs)
	if (locale === "sv") return sv_onboarding_resume_time_hint(inputs)
	return en_onboarding_resume_time_hint(inputs)
});